import { connect } from 'react-redux'
import dotProps from 'dot-prop-immutable'
import {
  BANNER_ALL,
} from '../../constant'

import {
  loadBannerAll,
  changeRoute,
} from '../../actions'
import {
  decodeQueryUrl,
} from '../../utils'

import BannerProduct from '../../components/pages/bannerProduct'

const expired = (times) => {
  return (times - Date.now() < 0 && times !== 0 ? true : false)
}
const filterCourseByExp = (typeExp, info) => {
  const { myLibCourse } = info
  let filterBannerTutor = []
  if (typeExp === '0') {
    filterBannerTutor = myLibCourse
  } else if (typeExp === '1') {
    filterBannerTutor = myLibCourse.filter(course => expired(course.product.expDate) === false)
  } else if (typeExp === '2') {
    filterBannerTutor = myLibCourse.filter(course => expired(course.product.expDate) === true)
  }
  const setFilterToBannerTutor = dotProps.set(info, 'myLibCourse', filterBannerTutor)
  return setFilterToBannerTutor
}
const filterBannerById = (banners, slugName) => {
  if(banners.filter(banner => banner._id === slugName).length > 0){
    return banners.filter(banner => banner._id === slugName)[0]
  }
  return null
}
const filterProductInBannerById = (banners, slugName, sortType) => {
  if(banners.filter(banner => banner._id === slugName).length > 0){
    let filterBanner =banners.filter(banner => banner._id === slugName)[0]
    let productAll=[
      ...filterBanner.productCourses,
      ...filterBanner.productExams,
      ...filterBanner.productPackages,
    ]
    if(sortType === '1'){
      return productAll.sort(function(a, b){
        var publicA=a.publishedDate, publicB=b.publishedDate;
        if (publicA < publicB) //sort string ascending
         return 1;
        if (publicA > publicB)
         return -1;
        return 0; //default return value (no sorting)
       });
    } else if(sortType === '2') {
      return productAll.sort(function(a, b){
        var ratingA=a.rating.avg, ratingB=b.rating.avg;
        if (ratingA < ratingB) //sort string ascending
         return 1;
        if (ratingA > ratingB)
         return -1;
        return 0; //default return value (no sorting)
       });
    }
    return productAll.sort(function(a, b){
      var nameA=a.productName.toLowerCase(), nameB=b.productName.toLowerCase();
      if (nameA < nameB) //sort string ascending
       return -1;
      if (nameA > nameB)
       return 1;
      return 0; //default return value (no sorting)
     });
  }
  return []
}

const mapStateToProps = ({
  pages: {
    banners,
  },
  info,
}, {
  location: {
    search,
  },
  match: {
    params: {
      slugName,
    },
  },
}) => {
  const {
    sortType,
  } = decodeQueryUrl(search)
  const isSortType = !!sortType
  return {
    // historyExam: filterBannerTutorById(slugName, info) !== [] ? filterBannerTutorById(slugName, info) : [],
    // info: filterCourseByExp(typeExp ? typeExp : '0', info),
    banners: filterBannerById(banners, slugName),
    productAll: filterProductInBannerById(banners, slugName, sortType),
    sortType: isSortType ? sortType : '0',
    params: search,
    info,
  }
}

const mapDispatchToProps = dispatch => ({
  onLoadBanner () {
    dispatch(loadBannerAll(BANNER_ALL))
  },
  onChangeRoute (pathName) {
    dispatch(changeRoute(pathName))
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(BannerProduct)



// WEBPACK FOOTER //
// ./src/containers/pages/BannerProduct.js